import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.88442 4.88442C7.37186 5.39699 7.37186 6.22801 7.88442 6.74058L12.9563 11.8125L7.88442 16.8844C7.37186 17.397 7.37186 18.228 7.88442 18.7406C8.39699 19.2531 9.22802 19.2531 9.74058 18.7406L15.7406 12.7406C15.9867 12.4944 16.125 12.1606 16.125 11.8125C16.125 11.4644 15.9867 11.1306 15.7406 10.8844L9.74058 4.88442C9.22801 4.37186 8.39699 4.37186 7.88442 4.88442Z'
            />
        </SvgIcon>
    );
});
